const prefix = 'SourcingProjectSupplier';

export enum SourcingProjectSupplierField {
  SOURCING_PROJECT_ID = `${prefix}.sourcingProjectId`,
  SUPPLIER_ID = `${prefix}.supplierId`,
  LOCATION_ID = `${prefix}.locationId`,
  NAME = `${prefix}.name`,
}

export interface SourcingProjectSupplierData {
  sourcingProjectId: string;
  supplierId: string;
  locationId: string;
  name?: string | null;
  proposalCount: number;
}

export interface SourcingProjectSupplierSegment extends SourcingProjectSupplierData {
  id: string;
}
